import TransactionClient from '@/network/transaction';
import type { RequestCreateTransaction } from '@/types';

export default {
    createTransaction(payload: RequestCreateTransaction) {
        return TransactionClient.createTransaction(payload);
    },
};
